import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { AuthRoutingModule } from './auth-routing.module';
import { SharedModule } from '@shared';
import { LoginComponent } from './login/login.component';

const COMPONENTS = [
  // ログイン画面
  LoginComponent
];

@NgModule({
  declarations: [...COMPONENTS,],
  imports: [
    CommonModule,
    AuthRoutingModule,
    SharedModule
  ]
})

export class AuthModule { }
